import React, { useState } from "react";
import { Link } from "react-router-dom";
import { features, business } from "../data";
import { FaPlay, FaYoutube, FaNewspaper, FaGlobe, FaAward, FaVideo, FaUserPlus } from "react-icons/fa";

const FeaturesPage = () => {
	const { items } = features;
	const [selectedVideo, setSelectedVideo] = useState(null);

	// Kohla News YouTube Videos - EMBED URLs
	const videos = [
		{
			id: 1,
			title: "Kohla News - Okara Ki Awaz, Punjab Ki Pehchan",
			description: "Welcome to Kohla News - Your trusted source for news from Okara, Punjab, and Pakistan",
			embedUrl: "https://www.youtube.com/embed/y-RDfXSHwmk",
			thumbnail: "https://img.youtube.com/vi/y-RDfXSHwmk/mqdefault.jpg",
			category: "Channel Intro",
			videoId: "y-RDfXSHwmk"
		},
		{
			id: 2,
			title: "Breaking News: Latest Updates from Punjab",
			description: "Stay updated with the latest breaking news from Punjab and Pakistan",
			embedUrl: "https://www.youtube.com/embed/lx_x2U0qEt0",
			thumbnail: "https://img.youtube.com/vi/lx_x2U0qEt0/mqdefault.jpg",
			category: "Breaking News",
			videoId: "lx_x2U0qEt0"
		},
		{
			id: 3,
			title: "Okara News - Local Updates",
			description: "Latest news and updates from Okara, Depalpur, and Renala Khurd",
			embedUrl: "https://www.youtube.com/embed/-OXaeFbulAQ",
			thumbnail: "https://img.youtube.com/vi/-OXaeFbulAQ/mqdefault.jpg",
			category: "Local News",
			videoId: "-OXaeFbulAQ"
		},
		{
			id: 4,
			title: "Pakistan News - National Updates",
			description: "Important national news and developments from across Pakistan",
			embedUrl: "https://www.youtube.com/embed/77ZJNYVunyU",
			thumbnail: "https://img.youtube.com/vi/77ZJNYVunyU/mqdefault.jpg",
			category: "National News",
			videoId: "77ZJNYVunyU"
		}
	];

	// YouTube Shorts - Also play on page using embed
	const shorts = [
		{
			id: 5,
			title: "Today Headlines - 05 July 2026",
			description: "Latest headlines from Kohla News",
			thumbnail: "https://img.youtube.com/vi/TchhgzEdAf8/mqdefault.jpg",
			embedUrl: "https://www.youtube.com/embed/TchhgzEdAf8",
			category: "Shorts",
			videoId: "TchhgzEdAf8"
		},
		{
			id: 6,
			title: "Kohla News Alert",
			description: "Breaking news alert from Kohla News",
			thumbnail: "https://img.youtube.com/vi/mPasyZuSAzg/mqdefault.jpg",
			embedUrl: "https://www.youtube.com/embed/mPasyZuSAzg",
			category: "Shorts",
			videoId: "mPasyZuSAzg"
		},
		{
			id: 7,
			title: "Pakistan Headlines",
			description: "Today's top headlines from Pakistan",
			thumbnail: "https://img.youtube.com/vi/eBrvD0ILWM4/mqdefault.jpg",
			embedUrl: "https://www.youtube.com/embed/eBrvD0ILWM4",
			category: "Shorts",
			videoId: "eBrvD0ILWM4"
		},
		{
			id: 8,
			title: "Daily News Update - 04 July 2026",
			description: "Daily news update from Kohla News",
			thumbnail: "https://img.youtube.com/vi/bDpdT3nBFPY/mqdefault.jpg",
			embedUrl: "https://www.youtube.com/embed/bDpdT3nBFPY",
			category: "Shorts",
			videoId: "bDpdT3nBFPY"
		}
	];

	// News Services
	const services = [
		{
			icon: "🔴",
			title: "Breaking News",
			description: "Get the latest breaking news as it happens, 24/7"
		},
		{
			icon: "🏘️",
			title: "Local Okara News",
			description: "Comprehensive coverage of Okara, Depalpur, and Renala Khurd"
		},
		{
			icon: "🇵🇰",
			title: "Pakistan News",
			description: "National news, politics, economy, and major events"
		},
		{
			icon: "🌍",
			title: "International News",
			description: "Global news and international affairs that impact Pakistan"
		}
	];

	const membershipFormLink = "https://docs.google.com/forms/d/e/1FAIpQLSeZoyJbhvsqmC4oM-W-aaNTLWl1GKCfgRQCq4483JoDCoRjTw/viewform?usp=publish-editor";

	return (
		<section className='section pt-32 min-h-screen bg-gray-50'>
			<div className='container mx-auto px-4'>
				
				{/* Back Button */}
				<Link to="/" className='inline-flex items-center text-blue-600 hover:text-blue-800 transition mb-8 font-medium group'>
					<span className="mr-2 group-hover:-translate-x-1 transition-transform">←</span>
					Back to Home
				</Link>

				{/* Header */}
				<div className='text-center mb-12'>
					<div className="inline-flex items-center gap-2 bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
						<FaNewspaper className="text-blue-600" />
						What We Offer
					</div>
					<h1 className='text-4xl md:text-5xl font-bold text-blue-900 mb-4'>Our News Coverage</h1>
					<p className='text-gray-600 text-lg max-w-2xl mx-auto'>
						Delivering accurate, timely, and reliable news from Okara, Punjab, Pakistan, and around the world
					</p>
				</div>

				{/* Features List */}
				<div className='grid md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-16'>
					{items.map((item, index) => (
						<div key={index} className='bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:scale-[1.02] border-l-4 border-yellow-500'>
							<div className='flex items-start gap-4'>
								<div className='text-blue-600 text-3xl'>{item.icon}</div>
								<div>
									<h3 className='text-lg font-semibold text-blue-900'>{item.title}</h3>
									<p className='text-gray-500 text-sm mt-1'>{item.subtitle}</p>
								</div>
							</div>
						</div>
					))}
				</div>

				{/* Membership Section */}
				<div className="max-w-4xl mx-auto mb-16">
					<div className="bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-10 text-white shadow-xl">
						<div className="flex flex-col md:flex-row items-center justify-between gap-6">
							<div className="flex-1">
								<div className="flex items-center gap-3 mb-3">
									<FaUserPlus className="text-yellow-400 text-3xl" />
									<h2 className="text-2xl md:text-3xl font-bold">Join Kohla News Membership</h2>
								</div>
								<p className="text-blue-200 mb-2">
									Get exclusive news updates, early access, and special benefits.
								</p>
								<div className="flex flex-wrap gap-3 mt-3">
									<span className="bg-blue-700/50 px-3 py-1 rounded-full text-sm flex items-center gap-1">
										<span className="text-green-400">✓</span> Exclusive alerts
									</span>
									<span className="bg-blue-700/50 px-3 py-1 rounded-full text-sm flex items-center gap-1">
										<span className="text-green-400">✓</span> Early access
									</span>
									<span className="bg-blue-700/50 px-3 py-1 rounded-full text-sm flex items-center gap-1">
										<span className="text-green-400">✓</span> Member-only content
									</span>
								</div>
							</div>
							<div className="flex-shrink-0">
								<a
									href={membershipFormLink}
									target="_blank"
									rel="noopener noreferrer"
									className="inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-blue-900 px-6 py-3 rounded-full font-bold text-lg transition-all duration-300 hover:scale-105 hover:shadow-lg"
								>
									⭐ Register Now
									<span className="text-sm">↗</span>
								</a>
								<p className="text-blue-300 text-xs mt-2 text-center">Opens in new tab</p>
							</div>
						</div>
					</div>
				</div>

				{/* YouTube Shorts Section */}
				<div className="mb-16">
					<h2 className='text-3xl font-bold text-blue-900 text-center mb-4 flex items-center justify-center gap-3'>
						<FaVideo className='text-red-600' />
						YouTube Shorts
						<span className='bg-red-500 text-white text-xs px-2 py-1 rounded-full'>NEW</span>
					</h2>
					<p className='text-center text-gray-600 mb-8 max-w-2xl mx-auto'>
						Click any short to watch it here on the page
					</p>

					<div className='grid grid-cols-2 md:grid-cols-4 gap-6 max-w-6xl mx-auto'>
						{shorts.map((short) => (
							<div 
								key={short.id}
								onClick={() => setSelectedVideo(short)}
								className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-105 group cursor-pointer"
							>
								<div className='relative'>
									<div className="relative w-full h-64 md:h-80 bg-gray-200">
										<img
											src={short.thumbnail}
											alt={short.title}
											className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
											onError={(e) => {
												e.target.src = "https://img.youtube.com/vi/TchhgzEdAf8/mqdefault.jpg";
											}}
										/>
										<div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/50 transition">
											<div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition">
												<FaPlay className="text-white text-2xl ml-1" />
											</div>
										</div>
									</div>
									<div className='absolute top-3 right-3 bg-red-600 text-white px-2 py-1 rounded-full text-xs font-semibold flex items-center gap-1'>
										<span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
										SHORT
									</div>
									<div className='absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded-full'>
										▶ Click to play
									</div>
								</div>
								<div className='p-4'>
									<h3 className='text-sm font-semibold text-blue-900 mb-1 line-clamp-2'>{short.title}</h3>
									<p className='text-gray-500 text-xs'>{short.description}</p>
								</div>
							</div>
						))}
					</div>
				</div>

				{/* Long Videos Section */}
				<h2 className='text-3xl font-bold text-blue-900 text-center mb-4 flex items-center justify-center gap-3'>
					<FaYoutube className='text-red-600' />
					Kohla News Videos
					<span className='w-10 h-1 bg-yellow-500 rounded-full'></span>
				</h2>
				<p className='text-center text-gray-600 mb-8 max-w-2xl mx-auto'>
					Click any video to watch it here on the page
				</p>

				<div className='grid md:grid-cols-2 gap-8 max-w-6xl mx-auto mb-16'>
					{videos.map((video) => (
						<div 
							key={video.id}
							onClick={() => setSelectedVideo(video)}
							className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] group cursor-pointer"
						>
							<div className='relative'>
								<div className="relative w-full h-56 md:h-64 bg-gray-200">
									<img
										src={video.thumbnail}
										alt={video.title}
										className="w-full h-full object-cover group-hover:scale-105 transition duration-500"
										onError={(e) => {
											e.target.src = "https://img.youtube.com/vi/y-RDfXSHwmk/mqdefault.jpg";
										}}
									/>
									<div className="absolute inset-0 bg-black/30 flex items-center justify-center group-hover:bg-black/50 transition">
										<div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center group-hover:scale-110 transition">
											<FaPlay className="text-white text-2xl ml-1" />
										</div>
									</div>
									<div className='absolute bottom-4 left-4 bg-blue-900/80 text-white px-3 py-1 rounded-full text-xs flex items-center gap-1'>
										<FaYoutube className='text-red-500' /> {video.category}
									</div>
									<div className='absolute bottom-4 right-4 bg-black/60 text-white text-xs px-2 py-1 rounded-full'>
										▶ Click to play
									</div>
								</div>
							</div>
							<div className='p-5'>
								<h3 className='text-lg font-semibold text-blue-900 mb-2 line-clamp-2'>{video.title}</h3>
								<p className='text-gray-500 text-sm'>{video.description}</p>
							</div>
						</div>
					))}
				</div>

				{/* Video Popup Modal */}
				{selectedVideo && (
					<div 
						className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4"
						onClick={() => setSelectedVideo(null)}
					>
						<div 
							className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-auto"
							onClick={(e) => e.stopPropagation()}
						>
							<div className="p-4 border-b flex justify-between items-center">
								<h3 className="font-bold text-blue-900">{selectedVideo.title}</h3>
								<button 
									onClick={() => setSelectedVideo(null)}
									className="text-gray-500 hover:text-gray-800 text-2xl"
								>
									✕
								</button>
							</div>
							<div className="p-4">
								<div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
									<iframe
										src={selectedVideo.embedUrl}
										title={selectedVideo.title}
										className="absolute top-0 left-0 w-full h-full rounded-lg"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
									></iframe>
								</div>
								<p className="text-gray-600 mt-4">{selectedVideo.description}</p>
								{selectedVideo.videoId && (
									<a
										href={`https://youtube.com/watch?v=${selectedVideo.videoId}`}
										target="_blank"
										rel="noopener noreferrer"
										className="inline-block mt-3 text-red-600 hover:text-red-800 font-medium"
									>
										▶ Watch on YouTube (opens in new tab)
									</a>
								)}
							</div>
						</div>
					</div>
				)}

				{/* Subscribe Button */}
				<div className='text-center mb-16'>
					<a 
						href={business.youtube}
						target='_blank'
						rel='noreferrer'
						className='inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105'
					>
						<FaYoutube className="text-xl" />
						Subscribe to Kohla News on YouTube
					</a>
				</div>

				{/* News Services Section */}
				<div className='max-w-5xl mx-auto'>
					<h2 className='text-3xl font-bold text-blue-900 text-center mb-4 flex items-center justify-center gap-3'>
						<FaGlobe className="text-blue-600" />
						Our News Services
						<span className='w-10 h-1 bg-yellow-500 rounded-full'></span>
					</h2>
					<p className='text-center text-gray-600 mb-8 max-w-2xl mx-auto'>
						Comprehensive news coverage across all categories
					</p>
					
					<div className='grid sm:grid-cols-2 lg:grid-cols-4 gap-6'>
						{services.map((service, index) => (
							<div key={index} className='bg-white p-6 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 hover:scale-[1.05] text-center group'>
								<div className='w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4 group-hover:bg-blue-600 transition-colors duration-300'>
									<span className='text-3xl group-hover:scale-110 transition-transform duration-300'>{service.icon}</span>
								</div>
								<h3 className='text-lg font-semibold text-blue-900'>{service.title}</h3>
								<p className='text-gray-500 text-sm mt-2'>{service.description}</p>
							</div>
						))}
					</div>
				</div>

				{/* Why Kohla News Section */}
				<div className='mt-16 max-w-5xl mx-auto bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-12 text-white'>
					<h2 className='text-3xl font-bold text-center mb-6 flex items-center justify-center gap-3'>
						<FaAward className="text-yellow-400" />
						Why Kohla News?
					</h2>
					<div className='grid md:grid-cols-3 gap-6'>
						<div className='text-center'>
							<div className='text-4xl mb-3'>⚡</div>
							<h3 className='font-semibold text-lg'>24/7 Coverage</h3>
							<p className='text-blue-200 text-sm'>Always on, always updating</p>
						</div>
						<div className='text-center'>
							<div className='text-4xl mb-3'>📰</div>
							<h3 className='font-semibold text-lg'>Trusted News</h3>
							<p className='text-blue-200 text-sm'>Accurate and verified reporting</p>
						</div>
						<div className='text-center'>
							<div className='text-4xl mb-3'>🤝</div>
							<h3 className='font-semibold text-lg'>Community Focus</h3>
							<p className='text-blue-200 text-sm'>Serving Okara and Punjab</p>
						</div>
					</div>
				</div>

				{/* Follow Us CTA */}
				<div className='mt-12 text-center'>
					<p className='text-gray-600 mb-4'>Stay informed with Kohla News</p>
					<div className='flex flex-wrap justify-center gap-4'>
						<a 
							href={business.youtube}
							target='_blank'
							rel='noreferrer'
							className='inline-flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg'
						>
							<FaYoutube /> YouTube
						</a>
						<a 
							href={business.facebook}
							target='_blank'
							rel='noreferrer'
							className='inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg'
						>
							Facebook
						</a>
						<a 
							href={business.whatsappLink}
							target='_blank'
							rel='noreferrer'
							className='inline-flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg'
						>
							💬 WhatsApp
						</a>
						<a 
							href={membershipFormLink}
							target='_blank'
							rel='noreferrer'
							className='inline-flex items-center gap-2 bg-yellow-500 hover:bg-yellow-400 text-blue-900 px-6 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg'
						>
							⭐ Membership
						</a>
					</div>
				</div>

			</div>
		</section>
	);
};

export default FeaturesPage;